import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import './signUp.css'


import SyncLoader from "react-spinners/SyncLoader";
// import { Formik, Form } from "formik";
import React from "react";
import { register_proceed } from "../../redux/actions";
import bcrypt from "bcryptjs";
import { Form, FormGroup, FormFeedback, Input, CustomInput } from "reactstrap";
import Regex from "../../utilities/regex";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../../firebase";
import { toast } from "react-toastify";
import { css } from "@emotion/react";

const SignUp = (props) => {
  let [loading, setLoading] = useState(false);
  const [disable, setdisable] = useState(false)
  const userDetails = useSelector((state) => state.userDetails.user);
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, seterrors] = useState();
  let [color, setColor] = useState("#ffffff");
  const [validate, setValidate] = useState(false);

  const callback = () => {
    setLoading(false)
    setdisable(false)
    setValidate(false);
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (validate) {
      console.log("errors after validation", errors);
      const fst = errors.firstName;
      const lst = errors.lastName;
      const em = errors.email;
      const pass = errors.password;
      const cPass = errors.confirmPassword;
      // console.log("firstname: ", !errors.firstName === false);
      // console.log("lastname: ", !errors.lastName === false);
      // console.log("email: ", !errors.email === true);
      // console.log("password: ", !errors.password === true);
      // console.log("condition sample test: ", !true && !true && !false && !false);
      // console.log("condition actual test: ", !errors.firstname && !errors.lastname && !errors.email && !errors.password);

      if (!fst && !lst && !em && !pass && !cPass) {
        try {
          const history = props.history;

          dispatch(register_proceed({
            history, data:
            {
              firstName: firstName.trim(),
              lastName: lastName.trim(),
              email: email.trim(),
              password: password.trim(),
            },
            callback
          }));

          //
        } catch (error) {
          console.error(error);
          callback()
          toast.error(error.message);
        }
      }
      else {
        callback();
        toast.error("Error!!! invalid values entered");
      }
    }
  }, [validate])


  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  // console.log("validation errors: ", errors);
  // console.log("validate: ", validate);

  // const onHandleChange = ({ target: { name, value } }) => {

  //   if (name === "email") {
  //     seterrors({ errors: { ...errors, [name]: false, }, [name]: value.replace(/\s/g, ""), });
  //   } else {
  //     seterrors({ errors: { ...errors, [name]: false, }, [name]: value, });
  //   }
  // };




  const handleSubmit = async (e) => {
    e.preventDefault()

    setLoading(true);
    setdisable(true);
    let obj = { firstName: false, lastName: false, email: false, password: false, confirmPassword: false };

    let encryptedpass = await bcrypt.hash(password, 10);
    if (!Regex.string(firstName)) {
      obj = { ...obj, firstName: true };
    }

    if (!Regex.string(lastName)) {
      obj = { ...obj, lastName: true };
    }

    if (!Regex.email(email)) {
      obj = { ...obj, email: true };
    }

    if (!Regex.password(password)) {
      obj = { ...obj, password: true };
    }

    if (confirmPassword !== password)
      obj = { ...obj, confirmPassword: true }

    seterrors(obj);
    setValidate(true);
  };



  return (


    <div className="col-12 inner-page-content login-page signup-section px-0  login-100 d-flex justify-content-center align-items-center ">
      <div id="login" className="my-4">
        <div className="login-container col-sm-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
          <div
            id="login-row"
            className="row justify-content-center align-items-center "
          >
            <div id="login-column" className="w-100">
              <h3 className="text-center page-head font-weight-bold  txtcolor">
                Sign Up
              </h3>
              <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">
                Enter your account details below
              </h5>
              <div id="login-box" className="col-md-12">
                <Form className="form site-form" onSubmit={handleSubmit}>
                  <FormGroup className="form-group mb-4">
                    <Input
                      id="firstName"
                      className="form-control input-style min-input"
                      name="firstName"
                      placeholder="First name"
                      type="text"
                      value={firstName}
                      required
                      onChange={(e) => {
                        // onHandleChange(e);
                        setFirstName(e.target.value)
                      }}
                      invalid={(firstName && !Regex.string(firstName))}
                    />
                    <FormFeedback id="firstname-err">
                      Please enter a valid first name.
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup className="form-group mb-4">
                    <Input
                      id="lastName"
                      className="form-control input-style min-input"
                      name="lastName"
                      placeholder="Last name"
                      type="text"
                      required="true"
                      value={lastName}
                      onChange={(e) => {
                        // onHandleChange(e);
                        setlastName(e.target.value)
                      }}
                      invalid={
                        (lastName && !Regex.string(lastName))}
                    />
                    <FormFeedback id="lastname-err">
                      Please enter a valid last name.
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup className="form-group mb-4">
                    <Input
                      id="email"
                      className="form-control input-style min-input"
                      name="email"
                      placeholder="Email address"
                      type="text"
                      value={email}
                      required="true"
                      onChange={(e) => {
                        // onHandleChange(e);
                        setemail(e.target.value)
                      }}
                      invalid={(email && !Regex.email(email))}
                    />
                    <FormFeedback id="email-err">
                      Please enter a valid email address.
                    </FormFeedback>{" "}
                  </FormGroup>
                  {/* <div className="form-group position-relative  mb-4"> */}
                  <FormGroup className="form-group position-relative  mb-4">
                    <Input
                      id="password"
                      type={showPassword ? "type" : "password"}
                      name="password"
                      required="true"
                      className="form-control input-style min-input"
                      placeholder="Password"
                      onChange={(e) => {
                        // onHandleChange(e);
                        setpassword(e.target.value)
                      }}
                      invalid={
                        (password && !Regex.password(password))}
                    />
                    <a
                      // href="/#"
                      className="pwd-show"
                      onClick={() =>

                        setshowPassword(!showPassword)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </a>

                    <FormFeedback id="password-err">
                      Password must be minimum 6 characters, at least one uppercase letter, one lowercase letter, one number and one special character
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup className="form-group position-relative  mb-4">
                    <Input
                      id="confirmPassword"
                      type={showConfirmPassword ? "type" : "password"}
                      name="confirmPassword"
                      required="true"
                      className="form-control input-style min-input"
                      placeholder="Confirm Password"
                      onChange={(e) => {
                        // onHandleChange(e);
                        setConfirmPassword(e.target.value)
                      }}
                      invalid={
                        (password !== confirmPassword)}
                    />
                    <a
                      // href="/#"
                      className="pwd-show"
                      onClick={() =>

                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {showConfirmPassword ? "Hide" : "Show"}
                    </a>

                    <FormFeedback id="confirm-password-err">
                      Passwords don't match
                    </FormFeedback>
                  </FormGroup>
                  <FormGroup className="form-group mb-4">
                    <button
                      type="submit"
                      className="btn  text-white w-100 btn-custom min-input mt-2"
                      disabled={disable}
                    >


                      {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                      {!loading && <span>Register</span>}

                    </button>
                  </FormGroup>
                </Form>
                <p className="w-100 text-center p-lght m-0">
                  Already on LiveStock?{" "}
                  <Link to={"/login"}>
                    <a>Sign in</a>


                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;